export const regions = [
    {
        id: 'none',
        label: 'Select country / region'
    },
    {
        id: 'us',
        label: 'United States'
    },
    {
        id: 'canada',
        label: 'Canada'
    },
    {
        id: 'uk',
        label: 'United Kingdom'
    },
    {
        id: 'eu',
        label: 'Europe (excluding the UK)'
    },
    {
        id: 'asiaPacific',
        label: 'Asia / Pacific'
    },
    {
        id: 'ausNz',
        label: 'Austrialia / New Zealand'
    },
    {
        id: 'latinAmerica',
        label: 'Latin America'
    },
    {
        id: 'africa',
        label: 'Africa'
    },
    {
        id: 'middleEast',
        label: 'Middle East'
    },
    {
        id: 'other',
        label: 'Other'
    }
];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/profile/formData/regions.ts